import React, { Component } from "react";
import { Toast } from 'react-bootstrap';

class ErrorToast extends Component {

  constructor() {
    super();

    this.state = {
      title: '',
      content: '',
      show: false
    };

    this.mount = false;
    this.toastRef = null;
  }

  componentDidMount() {
    let that = this;
    this.mount = true;
    if (!this.toastRef) {
      return;
    }

    this.toastRef.showError = function (title, message) {
      that.setState({
        title: title,
        content: message,
        show: true
      });
      setTimeout(() => {
        that.closeToast();
      }, 1 * 8 * 1000);
    };
  }

  componentWillUnmount() {
    this.mount = false;
  }

  closeToast = () => {
    if (this.mount) {
      this.setState({
        show: false,
      });
    }
  }

  render() {
    return (
    <div id={'errorToast'} ref={ref => this.toastRef = ref}>
      {(!this.state.show) ? null : (
      <Toast onClose={() => this.closeToast()}>
        <Toast.Header>
          {this.state.title}
        </Toast.Header>
        <Toast.Body>{this.state.content}</Toast.Body>
      </Toast>)}
    </div>);
  }
}

function showError(title, message, mainPageError = null) {
  let toast = document.getElementById('errorToast');
  if (toast) {
    toast.showError(title, message);
  }

  if (mainPageError) {
    let loadingArea = document.getElementsByClassName('contentLoding');
    if (loadingArea && loadingArea.length > 0) {
      loadingArea[0].forceResult(mainPageError);
    }
  }
}

export default ErrorToast;
export { showError };
